<button
  type="button"
  class="button-reset option-wrapper"
  (click)="optionClicked.emit(event())"
  (keydown)="onOptionKeyDown($event)"
  [tabindex]="event()">
  <shared-info-and-icon [icon]="icon()" [infoText]="option()" class="option" />
</button>
